import { useAppSelector } from "@store";
import { getIsTrialPlan } from "@store/account/selectors";
import { useMemo } from "react";

export const useShortUrl = (shortUrl?: string) => {
  const isTrial = useAppSelector(getIsTrialPlan);
  const url = useMemo(() => {
    if (!shortUrl) return "";
    let newUrl = shortUrl.replace("view.storydoc", "doc.storydoc");
    if (isTrial) newUrl = newUrl.replace("storydoc.com", "storydoc.ai");
    return newUrl;
  }, [isTrial, shortUrl]);

  return url;
};
